import React from 'react';
import BuscadorProductos from '../componentes/BuscadorProductos';

function Buscar(){
    
        return(
            
            <BuscadorProductos/>

           


        )
    
}

export default Buscar;